import { render, staticRenderFns } from "./mtcDetail.vue?vue&type=template&id=70663b44&scoped=true"
import script from "./mtcDetail.vue?vue&type=script&lang=js"
export * from "./mtcDetail.vue?vue&type=script&lang=js"
import style0 from "./mtcDetail.vue?vue&type=style&index=0&id=70663b44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70663b44",
  null
  
)

export default component.exports